export default __webpack_public_path__ + "static/media/Amulet of Pure Ice.f8daa884.jpg";